<template>
  <div class="border-box">
    <div class="flex items-center pl-4">
      <fa
        class="text-orange h1 mb-0 mr-6"
        icon="exclamation-circle"
      />
      <i18n-t
        data-i18n="calendar.tooManyFilters"
        keypath="calendar.tooManyFilters"
        tag="span"
      >
        <template #text>
          <span data-i18n="calendar.tooManyFiltersText">
            {{ $t('calendar.tooManyFiltersText') }}
          </span>
        </template>
        <template #link>
          <a
            class="font-bold"
            data-i18n="calendar.tooManyFiltersLink"
            @click="$emit('resetFilters')"
          >{{ $t('calendar.tooManyFiltersLink') }}</a>
        </template>
      </i18n-t>
    </div>
  </div>
</template>

<script>
export default defineNuxtComponent({
  emits: ['resetFilters'],
})
</script>